import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

interface ForcePaymentDialogProps {
  open: boolean;
  onCancel: () => void;
  onForce: () => void;
}

export const ForcePaymentDialog: FunctionComponent<ForcePaymentDialogProps> = ({
  open,
  onCancel,
  onForce,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Un paiement est déjà en cours
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography>
            {`Il semblerait qu'il y a déjà un paiement en cours pour cet événement.`}
          </Typography>
          <Typography>
            {`Si vous êtes allé au bout de la procédure de paiement (rentrer vos code de carte et validé) et que vous n'avez pas reçu de confirmation, contactez-nous.`}
          </Typography>
          <Typography>
            {`Si vous avez seulement arrêté la procédure avant la fin, vous pouvez continuer.`}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onForce} autoFocus sx={{ color: 'error.main' }}>
          Continuer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
